<template>
  <div>
    <div class="row t-head">
      <div class="col">{{ $t("DESCRIPTION_OF_OUTPUT_RAW_MATERIALS_AND_PACKAGING_MATERIALS") }}</div>
      <div class="col text-center">{{ $t("BATCH_NUMBER") }}</div>
      <div class="col text-center">{{ $t("EXPIRATION_DATE") }}</div>
      <div class="col text-center">{{ $t("QUANTITY") }}<br />{{ $t("COUNT_ABBREVIATION") }}</div>
      <div class="col text-center">{{ $t("INSERTED_QUANTITY") }}</div>
      <div class="col text-center">{{ $t("SAMPLE") }}</div>
      <div class="col text-center">{{ $t("MATERIAL_SCRAP") }}<br />{{ $t("COUNT_ABBREVIATION") }}</div>
      <div class="col text-center">{{ $t("RETURNED") }}<br />{{ $t("COUNT_ABBREVIATION") }}</div>
    </div>

    <template v-for="(cost, i) in costStandarts">
      <div class="row border-bottom" v-bind:key="'cs' + i">
        <div class="col text-strong">{{ cost.type }} {{ cost.name }}</div>
        <div class="col text-center">
          <span v-for="(b, kk) in cost.batch" v-bind:key="'csk' + kk">
            {{ b }}
          </span>
        </div>
        <div class="col text-center">{{ cost.expirationDate }}</div>
        <div class="col text-center">{{ cost.allQuantity }}</div>
        <template v-if="cost.primaryQIB > 0">
          <div class="col text-center">
            {{ cost.inputtedQuantity }}
          </div>
        </template>
        <template v-else>
          <div class="col text-center">X</div>
        </template>
        <div class="col text-center">{{ cost.allSample }}</div>
        <div class="col text-center">{{ cost.allScrap }}</div>
        <div class="col text-center">
          {{ cost.allReturned }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    calculateReturnedLoader: {
      required: true,
      type: Boolean,
    },

    saveCostStandardLoader: {
      required: true,
      type: Boolean,
    },

    routemap: {
      required: true,
      type: Object,
    },

    user: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      costStandarts: { ...this.routemap.costStandards },
    };
  },

  watch: {
    routemap() {
      this.costStandarts = { ...this.routemap.costStandards };
    },
  },
};
</script>

<style scoped>
.text-white {
  color: white;
}
</style>
